import {API_BASE_URL} from "../baseURL";

const EditMultiplicatorModal = ({ multiplicator, setMultiplicators, setShowEditMultiplicatorModal }) => {

    function save(multiplicatorId) {
        fetch(`${API_BASE_URL}/multiplicators/update-multiplicator`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: JSON.stringify(
                {
                    multiplicatorId:   parseInt(multiplicatorId),
                    firstName:         document.getElementById("firstname").innerHTML === '<br>' ? '' : document.getElementById("firstname").innerHTML,
                    surname:           document.getElementById("surname").innerHTML === '<br>' ? '' : document.getElementById("surname").innerHTML,
                    firm:              document.getElementById("firm").innerHTML === '<br>' ? '' : document.getElementById("firm").innerHTML,
                    comment:           document.getElementById("comment").innerHTML === '<br>' ? '' : document.getElementById("comment").innerHTML
                }
            )
        }).then(response => response.json())
            .then(data => setMultiplicators(data))
    }

    return (
        <>
            <div className="custom-modal">
                <div className="custom-modal-dialog">
                    <div>
                        <button onClick={() => setShowEditMultiplicatorModal(false)} style={{float: "right"}}> &times; </button>
                        <h4>Multiplikator: {multiplicator.surname}</h4>
                    </div>

                    <br/>

                    <input id="multiplicatorId" value={multiplicator.id} hidden/>

                    <table id="editMultiplicatorTable">
                        <tbody>
                            <tr>
                                <td><b> Nachname </b></td>
                                <td><div contentEditable="true" id="surname">{multiplicator.surname}</div></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> Vorname </b></td>
                                <td><div contentEditable="true" id="firstname">{multiplicator.firstName}</div></td>
                            </tr>

                            <tr>
                                <td><b> Unternehmen </b></td>
                                <td><div contentEditable="true" id="firm">{multiplicator.firm}</div></td>
                            </tr>

                            <tr>
                                <td><b> Kommentar </b></td>
                                <td><div contentEditable="true" id="comment">{multiplicator.comment}</div></td>
                            </tr>
                        </tbody>
                    </table>

                    <div style={{marginTop: "20px"}}>
                        <button onClick={() => { setShowEditMultiplicatorModal(false) }} className="custom-btn-close"> Schließen </button>
                        <button
                            onClick={() => {
                                setShowEditMultiplicatorModal(false)
                                save(document.getElementById("multiplicatorId").value)
                                }
                            }
                            className="custom-btn-save"> Speichern </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditMultiplicatorModal;
